import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Input, Menu, Modal, Space, Tag, Typography } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import React, { useState } from "react";
import { DataType } from "types";
import "./style.scss";

export const ManagePages: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const menu = (
		<Menu
			selectable
			// @ts-ignore
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	const columns: ColumnsType<DataType> = [
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
		},
		{
			title: "Age",
			dataIndex: "age",
			key: "age",
		},
		{
			title: "Address",
			dataIndex: "address",
			key: "address",
		},
		{
			title: "Tags",
			key: "tags",
			dataIndex: "tags",
			render: (_, { tags }) => (
				<>
					{tags.map((tag) => {
						let color = tag.length > 5 ? "geekblue" : "green";
						if (tag === "loser") {
							color = "volcano";
						}
						return (
							<Tag color={color} key={tag}>
								{tag.toUpperCase()}
							</Tag>
						);
					})}
				</>
			),
		},
		{
			title: "Action",
			key: "action",
			render: (_, record) => (
				<Space size="middle">
					<a href="www.google.com">Delete</a>
				</Space>
			),
		},
	];

	const data: DataType[] = [
		{
			key: "1",
			name: "John Brown",
			age: 32,
			address: "New York No. 1 Lake Park",
			tags: ["nice", "developer"],
		},
		{
			key: "2",
			name: "Jim Green",
			age: 42,
			address: "London No. 1 Lake Park",
			tags: ["loser"],
		},
		{
			key: "3",
			name: "Joe Black",
			age: 32,
			address: "Sidney No. 1 Lake Park",
			tags: ["cool", "teacher"],
		},
	];
	return (
		<div className="m-pages">
			<Modal
				title="Cadastrar nova página"
				visible={isOpen}
				onOk={() => setIsOpen(!isOpen)}
				onCancel={() => setIsOpen(!isOpen)}
			>
				<p>Some contents...</p>
				<p>Some contents...</p>
				<p>Some contents...</p>
			</Modal>
			<div className="m-pages__container">
				<h1 className="m-pages__container__title">Páginas</h1>
				<div className="m-pages__container__input">
					<div className="m-pages__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						usuários
					</div>
					<Input placeholder="Pesquisar..." />
					<button
						className="m-pages__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Página
					</button>
				</div>
				<Table columns={columns} dataSource={data} />
			</div>
		</div>
	);
};
